import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach token from localStorage as Bearer fallback (for cross-origin cookie hardening)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("corporaco_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Auto-attach current language as ?lang= for public GETs (insights), unless already set
  try {
    const lang = localStorage.getItem("corporaco_lang");
    if (lang) {
      config.params = { ...(config.params || {}) };
      if (!("lang" in config.params)) config.params.lang = lang;
    }
  } catch {
    /* ignore */
  }
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
